import { useIsFetching, useQuery } from "@tanstack/vue-query";
import { computed } from "vue";

import { getLanguage } from "@/api";

import { useUser } from "./api/useUser";

export function useCurrentLanguage() {
  const isLoginFetching = useIsFetching({ queryKey: ["login"] });
  const user = useUser();
  const query = useQuery({
    queryKey: ["language"],
    queryFn: async () => getLanguage(),
    enabled: computed(() => isLoginFetching.value === 0),
  });

  const data = computed(() =>
    query.data.value?.data?.results.find((lang) => lang.name === user.data.value?.current_mechanic),
  );
  const isFetching = computed(() => query.isFetching.value);

  return { data, isFetching };
}
